interface StorageManager { 
    loadGame(token?: string): Promise<Game>;
    recordQuestion(id: number, token?: string): Promise<number>;
    recordTrivia(id: number, token?: string): Promise<number>;
    recordGuess(guess: Guess, token?: string): Promise<number>;
    updateGameCompletion(completed: boolean): void;
    forceReload?(token?: string): Promise<Game>;
}

type Game = {
    firstname: string;
    middlename?: string;
    lastname: string;
    gameid: string;
    gamedate: string;
    questions: {
        standard: Question[];
        unique: Question[];
    };
    trivia: TriviaItem[];
    guesses: Guess[];
    asks: number[]; // Question IDs that have been asked
    triviaAsks: number[]; // Trivia IDs that have been asked
    score: number;
    gameCompleted?: boolean; // Whether the game has been completed
}

type Question = {
    answer: string;
    question: string;
    id: number;
}

type TriviaItem = {
    trivia: string;
    id: number;
}

type Guess = {
    firstname: string;
    lastname: string;
    middlename?: string;
}

const QUESTION_VALUE = 10;
const TRIVIA_VALUE = 10;
const GUESS_VALUE = 10;

export type { Game, Question, TriviaItem, Guess, StorageManager };
export { QUESTION_VALUE, TRIVIA_VALUE, GUESS_VALUE };